module.exports = __webpack_public_path__ + "assets/4ac092f92853c0599f4b9584157daa31.png";